<template>
    <div class="mt-2">
        <CTabs
            variant="pills"
            :active-tab="0"
        >

            <CTab title="Импорт" class="pt-1">
                <CRow form class="pl-3 pr-3 pt-3 align-items-center">
                    <CCol class="h3 mb-0">Импорт</CCol>
                    <CCol
                        v-if="type === 'restaurant' && integrationLoaded"
                        class="text-right"
                    >
                        <span class="integration-badge">{{ integrationTitle }}</span>
                    </CCol>
                </CRow>
                <CRow form class="pl-3 form-group">
                    <CCol sm="2" class="col-form-label">Статус:</CCol>
                    <CCol sm="10" class="col-form-label">{{ getStatusString }}</CCol>
                </CRow>
                <CRow form class="pl-3 pt-3 form-group">
                    <CCol sm="2" class="col-form-label">Последние обновление:</CCol>
                    <CCol sm="10" class="col-form-label">{{ lastUpdateDate }}</CCol>
                </CRow>
                <CSelect
                    class="pl-3 pt-3 form-group"
                    v-if="deliveryTerminals.length"
                    :value.sync="entity.delivery_terminal_id"
                    :options="deliveryTerminals"
                    label="Терминалы доставки"
                    placeholder="Выберите терминал"
                />
                <CRow
                    v-if="showTerminal && deliveryTerminals.length"
                    form
                    class="pl-3 pt-3 form-group">
                    <CCol sm="2" class="col-form-label">Импорт по терминалу доставки:</CCol>
                    <CCol sm="10" class="col-form-label">
                        <CSwitch
                            class="ml-5"
                            color="success"
                            shape="pill"
                            variant="opposite"
                            :checked.sync="useTerminal"
                        />
                    </CCol>
                </CRow>
                <!-- <CRow
                    form
                    class="pl-3 pt-3 form-group">
                    <CCol sm="2" class="col-form-label">Переводить позиции в "удаленные" при импорте:</CCol>
                    <CCol sm="10" class="col-form-label">
                        <CSwitch
                            class="ml-5"
                            color="success"
                            shape="pill"
                            variant="opposite"
                            :checked.sync="movePositionsToDeleted"
                        />
                    </CCol>
                </CRow> -->
                <CRow form class="pl-3 pt-3 form-group">
                    <CButton
                        color="info"
                        @click="fetch"
                    >Обновить</CButton
                    >
                    <CButton
                        v-if="importEnabled"
                        class="ml-4"
                        color="primary"
                        @click="run"
                    >Запустить импорт</CButton
                    >
                    <CButton
                        v-if="type === 'restaurant' && deliveryTerminals.length"
                        color="primary"
                        class="ml-4"
                        @click="save">Сохранить терминал</CButton>
                    <CButton
                        v-if="type === 'restaurant'"
                        color="danger"
                        class="ml-4"
                        @click="doExportNomenclature">Получить номенклатуру{{ integrationKindLabel }}</CButton>
                    <CButton
                        v-if="type === 'restaurant'"
                        color="danger"
                        class="ml-4"
                        @click="doExportStock">Получить сток{{ integrationKindLabel }}</CButton>
                </CRow>
            </CTab>

            <CTab title="Обновление стока" class="pt-1">
                <CRow form class="h3 pl-3 pt-3">Обновление стока</CRow>
                <CRow form class="pl-3 form-group">
                    <CCol sm="2" class="col-form-label">Статус:</CCol>
                    <CCol sm="10" class="col-form-label">{{ getStockStatusString }}</CCol>
                </CRow>
                <CRow form class="pl-3 pt-3 form-group">
                    <CCol sm="2" class="col-form-label">Последние обновление:</CCol>
                    <CCol sm="10" class="col-form-label">{{ stockLastUpdateDate }}</CCol>
                </CRow>
                <CRow form class="pl-3 pt-3 form-group">
                    <CButton
                        color="info"
                        @click="fetchStock"
                    >Обновить</CButton
                    >
                    <CButton
                        v-if="stockUpdateEnabled"
                        class="ml-4"
                        color="primary"
                        @click="runStockUpdate"
                    >Запустить обновление</CButton
                    >
                </CRow>
            </CTab>
            <CTab
                v-if="csvImport"
                title="Загрузка .csv"
                class="pt-1">
                <CRow
                    form
                    class="h3 pl-3 pt-3">Загрузка каталога из CSV</CRow>
                <CRow
                    v-if="!importMessage"
                    form
                    class="pl-3 pt-3 mb-2">Сейчас поддерживаются следующие поля:</CRow>
                <CRow v-if="!importMessage" class="ml-3 mb-4">
                    <ul>
                        <li>1. Category</li>
                        <li>2. Title</li>
                        <li>3. Price</li>
                    </ul>
                </CRow>
                <CForm v-if="!importMessage" class="pl-3">
                    <CInput
                        v-model="parentCategory"
                        horizontal
                        type="text"
                        placeholder="Введите название родительской категории"
                        label="Родительская категория для внутренних"
                    />
                    <CInputFile
                        ref="doc"
                        label="Загрузите .csv файл"
                        horizontal
                        @change="selectFile"
                    />
                </CForm>
                <CRow
                    v-if="!importMessage"
                    class="pl-3 pt-3 form-group">
                    <CButton
                        color="primary"
                        :disabled="!selectedFile"
                        @click="loadCvs"
                    >Начать загрузку</CButton
                    >
                </CRow>
                <CRow class="ml-3">{{ importMessage }}</CRow>
            </CTab>

            <CTab
                v-if="showVariablesTab"
                class="pt-1"
                title="Переменные"
            >
                <CRow class="h3 pl-3 pt-3">Крон выражения</CRow>
                <CRow class="pl-3"><CLink href="https://crontab.guru/#*/5_*_*_*_*" target="_blank">https://crontab.guru/#*/5_*_*_*_*</CLink></CRow>
                <CInput
                    v-if="importCronTick"
                    v-model="importCronTick"
                    class="pl-3 mt-4"
                    horizontal
                    type="text"
                    label="Импорт"
                    @keypress="successVariablesText = ''"
                />
                <CInput
                    v-if="stockCronTick"
                    v-model="stockCronTick"
                    class="pl-3 mt-4"
                    horizontal
                    type="text"
                    label="Сток"
                    @keypress="successVariablesText = ''"
                />
                <CRow class="h3 pl-3 pt-3">Переменные интеграции</CRow>
                <CRow
                    v-for="([key, val], index) in variables"
                    :key="index"
                    class="pl-3 mt-4"
                >
                    <CCol v-if="typeof val === 'object'">
                        <CRow class="pl-3">{{ key }}:</CRow>
                        <CRow
                            v-for="(field, ind) in Object.keys(val)"
                            :key="ind"
                            class="pl-3 pt-1"
                        >
                            <CCol>
                                <CInput
                                    v-model="importVariablesToSave[key][field]"
                                    horizontal
                                    type="text"
                                    :label="`${field} ${Array.isArray(importVariablesToSave[key][field]) ? '(массив “,”)' : ''}`"
                                    @keypress="successVariablesText = ''"
                                />
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol v-else>
                        <CInput
                            v-model="importVariablesToSave[key]"
                            horizontal
                            type="text"
                            :label="key"
                            @keypress="successVariablesText = ''"
                        />
                    </CCol>
                </CRow>
                <CRow class="pl-3 pt-3 form-group">
                    <CButton
                        color="primary"
                        @click="saveVariables"
                    >Сохранить</CButton
                    >
                    <span v-if="successVariablesText" class="ml-2 pt-2">{{ successVariablesText }}</span>
                </CRow>
            </CTab>

            <CTab
                v-if="adminOnly && type === BUSINESS_TYPE.RESTAURANT"
                class="pt-1"
                title="Копирование"
            >
                <CopyTab :id="id" :type="type" />
            </CTab>

            <CTab
                v-if="adminOnly"
                class="pt-1"
                title="Сброс"
            >
                <RebootTab :id="id" :type="type" />
            </CTab>

        </CTabs>
        
    </div>
</template>

<script>
    import Vue from 'vue';
    import to from 'await-to-js';
    import { IMPORT_STATUS } from '../../utils/import';
    import { BUSINESS_TYPE } from '../../utils/order';
    import RebootTab from '@/components/import/RebootTab';
    import CopyTab from '@/components/import/CopyTab';
    import moment from 'moment';

    export default {
        components: {
            RebootTab,
            CopyTab
        },

        props: {
            type: {
                type: String,
                default: '',
            },
            id: {
                type: Number,
                default: null,
            },
            showTerminal: {
                type: Boolean,
                default: false,
            },
            csvImport: {
                type: Boolean,
                default: false,
            }
        },

        data: () => ({
            entity: undefined,
            deliveryTerminals: [],
            integration: null,
            integrationLoaded: false,
            status: 0,
            stockStatus: 0,
            lastUpdateDate: '',
            stockLastUpdateDate: '',
            useTerminal: false,
            movePositionsToDeleted: false,
            selectedFile: null,
            importMessage: '',
            parentCategory: '',
            statusId: null,
            importVariables: {},
            importVariablesToSave: {},
            importCronTick: '',
            stockId: null,
            stockCronTick: '',
            showVariablesTab: false,
            successVariablesText: '',
            BUSINESS_TYPE
        }),

        computed: {
            importEnabled() {
                return (
                    this.status === IMPORT_STATUS.AVAILABLE ||
                    this.status === IMPORT_STATUS.COMPLETED ||
                    this.status === IMPORT_STATUS.ERROR
                );
            },
            stockUpdateEnabled() {
                return (
                    this.stockStatus === IMPORT_STATUS.AVAILABLE ||
                    this.stockStatus === IMPORT_STATUS.COMPLETED ||
                    this.stockStatus === IMPORT_STATUS.ERROR
                );
            },
            getStatusString() {
                return this.statusString(this.status);
            },
            getStockStatusString() {
                return this.stockStatusString(this.stockStatus);
            },
            variables() {
                if (Object.entries(this?.importVariables).length) {
                    return [...Object.entries(this.importVariables)];
                }
                return [];
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
            integrationTitle() {
                if (!this.integration) {
                    return 'не подключена';
                }
                const kindTitles = {
                    iiko: 'iiko',
                    yuma: 'Yuma'
                };
                const kind = kindTitles[this.integration.kind] || this.integration.name;
                const name = this.integration.name;
                if (!name || String(name).toLowerCase() === String(kind).toLowerCase()) {
                    return kind;
                }
                return `${kind} — ${name}`;
            },
            integrationKindLabel() {
                if (!this.integration) {
                    return '';
                }
                return ` (${this.integrationTitle})`;
            },
        },

        watch: {
            async useTerminal(val) {
                if (typeof val === 'boolean') {
                    await this.axios.post(`/import/terminal/${this.type}/${this.id}`, { use_terminal: !!val });
                }
            },
            async movePositionsToDeleted(val) {
                if (typeof val === 'boolean') {
                    await this.axios.post(`/import/position/${this.type}/${this.id}`, { move_positions_to_deleted: !!val });
                }
            },
        },

        async created() {
            await this.fetch();
            await this.fetchStock();
        },

        methods: {
            async save() {
                try {
                    await Vue.axios.post('/restaurants/update/' + this.$route.params.id, this.entity);
                    this.$root.$emit('showAlert', 'Терминал сохранен.')
                } catch (e) {
                    this.$root.$emit('showError', `Ошибка сохранения. \n\n${e.response.data.error}`);
                }
            },
            async doExportNomenclature() {
                try {
                    this.axios.get(`/export/restaurant/${this.id}`)
                        .then(response => {
                            var jsonse = JSON.stringify(response.data, null, 4);
                            const fileURL = window.URL.createObjectURL(new Blob([jsonse], { type: 'application/json' }));
                            const fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            fileLink.setAttribute('download', 'Export-MIRCITY-Nomenclature.json');
                            document.body.appendChild(fileLink);

                            fileLink.click();
                        });
                } catch (e) {}
            },
            async doExportStock() {
                try {
                    this.axios.get(`/export/stock/${this.id}`)
                        .then(response => {
                            var jsonse = JSON.stringify(response.data, null, 4);
                            const fileURL = window.URL.createObjectURL(new Blob([jsonse], { type: 'application/json' }));
                            const fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            fileLink.setAttribute('download', 'Export-MIRCITY-Nomenclature.json');
                            document.body.appendChild(fileLink);

                            fileLink.click();
                        });
                } catch (e) {}
            },
            selectFile(FileList) {
                if (FileList[0].type !== 'text/csv' || !FileList[0].name.includes('.csv')) {
                    this.$root.$emit('showError', 'Файл должен быть в формате .csv!');
                    setTimeout(() => {
                        this.$refs.doc.value = null;
                    }, 1000);
                    return;
                }
                this.selectedFile = FileList[0];
            },

            async fetch() {
                this.status = 0;
                const [error, result] = await to(
                    this.axios.get(`/import/status/${this.type}/${this.id}`)
                );
                this.statusId = result.data.id ? result.data.id : null;
                this.status = result.data.status;
                this.useTerminal = result.data.use_terminal;
                this.movePositionsToDeleted = result.data.move_positions_to_deleted;
                this.lastUpdateDate = result.data.updated_at ? moment(result.data.updated_at).format('YYYY-MM-DD HH:mm:ss') : 'Не найдено';
                this.importVariables = { ...this.importVariables, ...result.data.variables };
                this.importVariablesToSave = await JSON.parse(JSON.stringify(this.importVariables));
                this.importCronTick = result.data.cron_tick;
                if (Object.entries(this.importVariables).length) {
                    this.showVariablesTab = true;
                }

                if (error) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных. ' + error);
                }

                if (this.type === 'restaurant') {
                    const id = this.$route.params.id;
                    const [error, result] = await to(this.axios.get(`/restaurants/${id}`));
                    if (error) {
                        return this.$root.$emit('showError', 'Ошибка загрузки ресторана. ' + error);
                    }
                    this.entity = result.data;
                }
                if (this.type === 'restaurant' && this.entity && this.entity.alias) {
                    try {
                        const deliveryTerminals = await Vue.axios.get(`/integration/iiko/delivery-terminals/${this.entity.alias}`);
                        const terminals = deliveryTerminals.data.deliveryTerminals || [];
                        this.deliveryTerminals = terminals.map(terminal => ({
                            label: `${terminal?.address} - ${terminal?.name}`,
                            value: terminal.deliveryTerminalId
                        }));
                        this.integration = deliveryTerminals.data.integration || null;
                    } catch (error) {
                        this.deliveryTerminals = [];
                        this.integration = null;
                    }
                }
                if (this.type === 'restaurant') {
                    this.integrationLoaded = true;
                }
            },

            async fetchStock() {
                this.stockStatus = 0;
                const [error, result] = await to(
                    this.axios.get(`/stock/status/${this.type}/${this.id}`)
                );
                this.stockId = result.data.id;
                this.stockCronTick = result.data.cron_tick;
                this.stockStatus = result.data.status;
                this.stockLastUpdateDate = result.data.updated_at ? moment(result.data.updated_at).format('YYYY-MM-DD HH:mm:ss') : 'Не найдено';

                if (error) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных. ' + error);
                }
            },

            async run() {
                this.status = 0;
                const [error, result] = await to(
                    this.axios.get(`/import/run/${this.type}/${this.id}`)
                );
                this.status = result.data.status;
            },

            async runStockUpdate() {
                this.stockStatus = 0;
                const [error, result] = await to(
                    this.axios.get(`/stock/run/${this.type}/${this.id}`)
                );
                this.stockStatus = result.data.status;
            },

            async loadCvs() {
                let formData = new FormData();
                formData.append('file', this.selectedFile);
                this.importMessage = 'Загрузка в успешно начата!';
                this.axios
                    .post('/files/upload-raw', formData)
                    .then(resp => {
                        this.axios
                            .post('/import/csv', {
                                type: this.type,
                                id: this.id,
                                filename: resp.data.filename,
                                parentCategory: this.parentCategory
                            })
                            .then(({ data }) => {
                                this.importMessage = data.message;
                            })
                            .catch(err => {
                                this.importMessage = err.data.message;
                            });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки файла. ' + err);
                    });
            },

            async saveVariables() {
                if (this.statusId) {
                    try {
                        this.formatVariables();
                        await this.axios.post('/import/update/', {
                            variables: this.importVariablesToSave,
                            id: this.statusId,
                            cron_tick: this.importCronTick,
                            stock_id: this.stockId,
                            stock_cron_tick: this.stockCronTick
                        });
                        this.successVariablesText = 'Переменные успешно сохранены.';
                    } catch (error) {
                        console.log(error);
                        this.successVariablesText = 'Не удалось сохранить переменные.';
                    }
                }
            },

            formatVariables() {
                try {
                    const arraysToFormat = this.three(this.importVariables);
                    if (Array.isArray(arraysToFormat) && arraysToFormat?.length) {
                        arraysToFormat.forEach(pathes => {
                            const path = pathes.split('.');
                            switch (path.length) {
                            case 1:
                                this.importVariablesToSave[path[0]] = Array.isArray(this.importVariablesToSave[path[0]]) 
                                    ? this.importVariablesToSave[path[0]]
                                    : this.importVariablesToSave[path[0]].split(',');
                                break;
                            case 2:
                                this.importVariablesToSave[path[0]][path[1]] = Array.isArray(this.importVariablesToSave[path[0]][path[1]])
                                    ? this.importVariablesToSave[path[0]][path[1]]
                                    : this.importVariablesToSave[path[0]][path[1]].split(',');
                                break;
                            case 3:
                                this.importVariablesToSave[path[0]][path[1]][path[2]] = Array.isArray(this.importVariablesToSave[path[0]][path[1]][path[2]])
                                    ? this.importVariablesToSave[path[0]][path[1]][path[2]]
                                    : this.importVariablesToSave[path[0]][path[1]][path[2]].split(',');
                                break;
                            
                            default: return;
                            }
                        })
                    }
                } catch (error) {
                    console.log(error);
                    this.successVariablesText = 'Не удалось сохранить переменные.';
                }
            },

            three (tr) {
                const isArray = Array.isArray || function (arr) {
                    return Object.prototype.toString.call(arr) === '[object Array]';
                }
                const isObject = function (obj) {
                    return Object.prototype.toString.call(obj) === '[object Object]';
                }

                var paths = [];

                function findPath(branch, str) {
                    Object.keys(branch).forEach(function (key) {
                        if (isObject(branch[key])) {
                            findPath(branch[key], str ? str + '.' + key : key);
                        } else if (isArray(branch[key])) {
                            paths.push(str ? str + '.' + key : key);
                        }
                    });
                }

                findPath(tr, '');

                return paths;
            },

            statusString(statusId) {
                switch (statusId) {
                case IMPORT_STATUS.AVAILABLE: return 'Импорт доступен';
                case IMPORT_STATUS.UNAVAILABLE: return 'Импорт недоступен';
                case IMPORT_STATUS.INPROGRESS: return 'В процессе...';
                case IMPORT_STATUS.COMPLETED: return 'Импорт завершен';
                case IMPORT_STATUS.ERROR: return 'Ошибка импорта';
                }
                return 'Загрузка...';
            },

            stockStatusString(statusId) {
                switch (statusId) {
                case IMPORT_STATUS.AVAILABLE: return 'Обновление доступно';
                case IMPORT_STATUS.UNAVAILABLE: return 'Обновление недоступно';
                case IMPORT_STATUS.INPROGRESS: return 'В процессе...';
                case IMPORT_STATUS.COMPLETED: return 'Обновление завершено';
                case IMPORT_STATUS.ERROR: return 'Ошибка обновления';
                }
                return 'Загрузка...';
            },
        },
    };
</script>

<style scoped>
.integration-badge {
    display: inline-block;
    padding: 0.15rem 0.6rem;
    border-radius: 999px;
    background: #e7f3ff;
    color: #0b5cab;
    font-size: 0.8rem;
    font-weight: 600;
    line-height: 1.4;
}
</style>
